// store/features/extension.feature.tsx
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '../base-query';
import { expectedOrganizationHeaders } from '@/store/expected-organization-headers';

export interface OrganizationCredits {
  /** Available now. Credits running Clu work holds are not in it. */
  count: number;
  /** Credits the org's running Clu work holds (any member's chat, a Slack
   *  turn, an agent run); they settle back when that work ends. */
  reserved?: number;
  email_credits: number;
  phone_credits: number;
  last_updated: string;
  organization_id?: string;
}

export interface OrganizationCreditsScope {
  organizationId: string;
}

const assertOrganizationCreditsResponse = (
  response: OrganizationCredits,
  organizationId: string
): OrganizationCredits => {
  if (
    typeof response.organization_id === 'string' &&
    response.organization_id !== organizationId
  ) {
    throw new Error('Credits response did not match the active organization.');
  }
  return response;
};

export const extensionApi = createApi({
  reducerPath: 'extensionApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['Credits'],
  endpoints: (builder) => ({
    // Get organization credits
    getOrganizationCredits: builder.query<
      OrganizationCredits,
      OrganizationCreditsScope
    >({
      query: ({ organizationId }) => ({
        url: '/extension/credits',
        headers: expectedOrganizationHeaders(organizationId),
      }),
      transformResponse: (
        response: OrganizationCredits,
        _meta,
        { organizationId }
      ) => assertOrganizationCreditsResponse(response, organizationId),
      providesTags: (_result, _error, { organizationId }) => [
        { type: 'Credits', id: organizationId },
      ],
    }),
  }),
});

export const { useGetOrganizationCreditsQuery } = extensionApi;
